import { useParams } from 'react-router-dom';
import ModelConfiguratorDetailsInnerPage from './ModelConfiguratorDetailsInnerPage';
import ModelConfiguratorProvider from './ModelConfiguratorProvider';

const ModelConfiguratorDetailsPage = () => {
    const { modelConfiguratorId } = useParams<{ modelConfiguratorId: string }>();

    return (
        <ModelConfiguratorProvider modelConfiguratorId={modelConfiguratorId} isEdit>
            <ModelConfiguratorDetailsInnerPage />
        </ModelConfiguratorProvider>
    );
};

export default ModelConfiguratorDetailsPage;
